import { Directive, HostListener, signal } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

// A generic constructor type
type Constructor<T = {}> = new (...args: any[]) => T;

/**
 * Mixin that adds an `isMobile` WritableSignal<boolean>
 * which updates on window resize (<= 816).
 *
 * You can call `WithResponsive()` with no args, or pass
 * another base class if you need to mix with an existing one.
 */
export function WithMobileDetection<TBase extends Constructor = Constructor>(
  Base: TBase = class {
  } as TBase
) {
  @Directive() // so @HostListener works without a selector
  class ResponsiveMixin extends Base {
    /** true if viewport width <= 816 */
    /**
     * @deprecated use isMobile as signal instead
     */
    readonly isMobile$ = new BehaviorSubject(window.innerWidth <= 816);

    readonly isMobile = signal(window.innerWidth <= 816);

    @HostListener('window:resize', ['$event'])
    private onResize(event: UIEvent) {
      const w = (event.target as Window).innerWidth;
      this.isMobile$.next(w <= 816);
      this.isMobile.set(w <= 816);
    }
  }

  return ResponsiveMixin;
}
